import { gql } from '@apollo/client';

const GET_FILTERS = gql`
  query getFilters($limit: Int = 1000) {
    getFilters(limit: $limit) {
      orderFilterOptions {
        sellers {
          id
          name
        }
        warehouses {
          id
          name
          computedAddress {
            label
          }
        }
      }
      catalogFilterOptions {
        sellers {
          id
          name
        }
        warehouses {
          id
          name
        }
      }
      sellerFilterOptions {
        sellers {
          id
          name
        }
      }
      correctionFilterOptions {
        sellers {
          id
          name
        }
        warehouses {
          id
          name
        }
      }
      transferFilterOptions {
        sellers {
          id
          name
        }
        warehouses {
          id
          name
        }
      }
    }
  }
`;

export default GET_FILTERS;
